import {Box, LinkButton, Modal, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {FC} from 'react'

import * as classes from './BusinessModal@mobile.classes'
import {useBusinessBannerModal} from './hooks'
import type {BusinessModalProps} from './types'

const BusinessModal: FC<BusinessModalProps> = props => {
  const {isActive, setActive} = props
  const i18n = useI18n()
  const {title, list, description, imageSrc, link, handleRegisterLinkClick, handleClose} =
    useBusinessBannerModal(setActive)

  return (
    <Modal className={classes.modal} data-e2e="business-modal" onClose={handleClose} opened={isActive}>
      <Modal.Header pb="s" pt="xl">
        <div className={classes.clickMask} onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Typography color="invert" group="normal" mb="m" thickness="bold" variant="title3">
          {title}
        </Typography>
        <Typography color="invert" Component="div" group="loose" variant="body2">
          {description}
        </Typography>
        {list.length > 0 ? (
          <Typography color="invert" Component="div" group="loose" ml="xl" mt="m" variant="body2">
            <ul>
              {list.map((text, i) => (
                <li key={`business-banner-point-${i}`}>{text}</li>
              ))}
            </ul>
          </Typography>
        ) : null}
        <Box className={classes.image} mt="m" style={{backgroundImage: `url(${imageSrc})`}} />
      </Modal.Body>
      <Modal.Footer className={classes.footer}>
        <LinkButton href={link} onPress={handleRegisterLinkClick} variant="floating" fullWidth>
          {i18n('order.banner.button.register', 'Зарегистрироваться')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
}

BusinessModal.displayName = 'Business_Modal'

export {BusinessModal}
